import { scrollToElement } from './utils.js'

let $sections = document.querySelectorAll(".js-collapsible");
let $toggles = [];

function eventFire(el, etype) {
  if (el.fireEvent) {
    el.fireEvent("on" + etype);
  } else {
    var evObj = document.createEvent("Events");
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}

if ($sections.length) {
  Array.from($sections).forEach(init);
}

function init($section, i) {
  let $title = $section.querySelector("h1, h2, h3, h4, h5, h6");
  let $toggle = document.createElement("button");
  $toggle.type = "button";
  $toggle.className = $title.className;

  $title.className = "";
  $toggle.setAttribute("aria-expanded", "false");
  moveChildren($title, $toggle);
  $title.appendChild($toggle);
  $toggles.push($toggle);

  let $content = $title.nextElementSibling;
  $content.hidden = true;

  if (!$section.getAttribute("data-start-open")) {
    $section.setAttribute("data-open", "false");
  } else {
    toggleOpen($content, $toggle, $section);
  }

  $toggle.addEventListener("click", () => {
    if ($section.getAttribute("data-toggleable") == "false") return;

    if ($section.getAttribute("data-exclusive-open")) {
      $sections.forEach($xSection => {
        let $xTitle = $xSection.querySelector("h1, h2, h3, h4, h5, h6");
        let $xContent = $xTitle.nextElementSibling;
        let $xToggle = $xTitle.querySelector("button");
        collapse($xContent, $xToggle, $xSection);
      });
    }

    toggleOpen($content, $toggle, $section);
  });

  const $next = $section.querySelector(".js-next-collapsible");

  if ($next) {
    $next.addEventListener("click", e => {
      e.preventDefault();
      const $nextToggle = $toggles[i + 1];
      if ($nextToggle) {
        eventFire($nextToggle, "click");
      }
    });
  }
}

function moveChildren(oldParent, newParent) {
  while (oldParent.childNodes.length > 0) {
    newParent.appendChild(oldParent.childNodes[0]);
  }
}

function toggleOpen($content, $toggle, $section) {
  $content.hidden = !$content.hidden;
  $toggle.setAttribute("aria-expanded", $content.hidden ? "false" : "true");
  $section.setAttribute("data-open", $content.hidden ? "false" : "true");
}

function collapse($content, $toggle, $section) {
  $content.hidden = true;
  $toggle.setAttribute("aria-expanded", "true");
  $section.setAttribute("data-open", "false");
}



// WEBPACK FOOTER //
// ./src/js/_collapsible.js